import { Component,EventEmitter, OnInit, Output } from '@angular/core';
import { SpraValidationAfterSalesAdmin } from 'src/app/Models/master';
import { MasterService } from 'src/app/Services/master.service';

@Component({
  selector: 'app-spra-validation-hierarchy',
  templateUrl: './spra-validation-hierarchy.component.html',
  styleUrls: ['./spra-validation-hierarchy.component.css']
})
export class SpraValidationHierarchyComponent implements OnInit {
  @Output("ValidationHierarchyChange") ValidationHierarchyChange: EventEmitter<any> = new EventEmitter();
  ValidationLevel: Array<SpraValidationAfterSalesAdmin>;
  EmployeeCodes: any[] = [];
  

  constructor(private _MasterService:MasterService) {
    this.ValidationLevel = new Array<SpraValidationAfterSalesAdmin>();

    let _SpraValidationAfterSalesAdmin:SpraValidationAfterSalesAdmin;
     let i:number=1
     for(i;i<=5;i++){
      _SpraValidationAfterSalesAdmin= new SpraValidationAfterSalesAdmin();
      _SpraValidationAfterSalesAdmin.SrNo =i;
      this.ValidationLevel.push(_SpraValidationAfterSalesAdmin);
     }
    
   }

  ngOnInit(): void {
  }


  onEmployeeCodeKeypress(event:any){
    if(event.key !=  "ArrowDown" && event.key !=  "ArrowUp"){
    if(event.target.value.length>2){
      
      this.EmployeeCodes=[];
      this._MasterService.GetEmployeeCodeForAutocomplete(event.target.value).subscribe((d) => {
       if(d){
        let EmployeeList:any=[];
        EmployeeList  = EmployeeList.concat(d);
        if(this.ValidationLevel.filter((t1:any) => {return t1.EmployeeId != undefined}).length>0){
          EmployeeList = EmployeeList.filter((t:any) => {return  this.ValidationLevel.filter((t1:any) => {return t1.EmployeeId == t.employeeId}).length<=0 });

        }
        this.EmployeeCodes = this.EmployeeCodes.concat(EmployeeList);
       }
    }); 
    }else{
      this.EmployeeCodes = [];
    }
  }
  }
  
  
  EmployeeModelChange(){
    this.ValidationHierarchyChange.emit(this.ValidationLevel);
  }


}
